module.exports = __webpack_public_path__ + "386528e1deea545332dc0aae7b3f2c8d.fbx";